import CardTable from "components/CardTable/CardTable";
import React, { useCallback } from "react";
import WidgetsIcon from "@material-ui/icons/Widgets";
import { useDispatch, useSelector } from "react-redux";
import { saveInventory } from "redux/actions/inventories/inventoriesAction";
import { setConfigFilteredInventories } from "redux/actions/inventories/inventoriesAction";
import { setConfigSortedInventories } from "redux/actions/inventories/inventoriesAction";
import { setConfigPageInventoriesCount } from "redux/actions/inventories/inventoriesAction";
import { setConfigPageInventories } from "redux/actions/inventories/inventoriesAction";
import { SaveInventoryButton } from "./SaveInventoryButton";
 
export const MobileTable = ({
  title = "",
  columns = [],
  keyInventory = "",
  endpoint = "",
  edited = ""
}) => {
  const keyTable = "mobileConfig";
  const dispatch = useDispatch();
  const { inventory, mobileConfig,} = useSelector(
    ({ inventories }) => inventories
  );
  const { mobileInventory } = inventory?.details;
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { filtered, sorted, page, pageSize } = mobileConfig;

  const handleSave = (e) => {
    e.preventDefault();
    const data = mobileInventory.map(inv => {
      const {totalKg, ...rest} = inv
      return rest
    })
    dispatch(
      saveInventory(inventory.id, endpoint, data, keyInventory)
    );
  };


  const handleFilter = useCallback((e) => {
    dispatch(setConfigFilteredInventories(keyTable, e));
  }, []);

  const handleSort = useCallback((e) => {
    dispatch(setConfigSortedInventories(keyTable, e));
  }, []);

  const handlePageCount = useCallback((e) => {
    dispatch(setConfigPageInventoriesCount(keyTable, e));
  }, []);

  const handlePageSize = useCallback((e) => {
    dispatch(setConfigPageInventories(keyTable, e));
  }, []);

  return (
    <>
      <CardTable
        hasHeader
        title={title}
        icon={<WidgetsIcon />}
        blockBtn
        columns={columns}
        data={inventory?.details?.mobileInventory}
        filtered={filtered}
        page={page}
        pageSize={pageSize}
        sorted={sorted}
        onFilteredChange={handleFilter}
        onPageSizeChange={handlePageSize}
        onPageChange={handlePageCount}
        onSortedChange={handleSort}
        hasControl={inventory[edited] ? true : false}
        isLoading={isLoadingComp?.loadingInventoryType}
        controls={<SaveInventoryButton  handleSave={handleSave} />}
      />
    </>
  );
};
